module.exports = __webpack_public_path__ + "img/android.672370dd.png";